import axios from 'axios'
import axiosRetry from 'axios-retry'
// import { notification } from 'antd'
import { firebaseAuth } from '../firebase'

export const BACKEND_BASE_URL = 'https://api.stift.com.br/v1'

const apiClient = axios.create({
  // baseURL: 'https://ea2a-2804-4d98-262-2f00-307e-4bdc-ab00-9d74.ngrok-free.app/v1',
  baseURL: BACKEND_BASE_URL,
  // baseURL: 'http://192.168.1.20:3500/v1',
  // timeout: 1000,
  // headers: { 'X-Custom-Header': 'foobar' }
})

axiosRetry(apiClient, {
  retries: 3,
  retryDelay: axiosRetry.exponentialDelay,
})

apiClient.interceptors.request.use(async request => {
  request.headers.Authorization = await firebaseAuth.currentUser.getIdToken()
  return request
})

export default apiClient
